import numeral from 'numeral'

import { DISPLAY_VALUES } from './constants'

/**
 * Renders one matrix cell.
 *
 * Numbers get thousand separators (5395 -> "5,395") and keep whatever precision
 * the backend sent, up to the three decimals it rounds ADG to — trailing zeros are
 * trimmed, so 0.082 stays "0.082" while 255 stays "255" rather than "255.000".
 *
 * Blank, null and undefined all mean "nothing recorded for this pond on this date"
 * and render as a dash. 0 is a real measurement and must survive: a fed-zero day or
 * a pond with no wounds is not the same as an unrecorded one.
 */
export const formatCellValue = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') return DISPLAY_VALUES.EMPTY

  if (typeof value === 'number') {
    return Number.isFinite(value) ? numeral(value).format('0,0.[000]') : DISPLAY_VALUES.EMPTY
  }

  return value
}
